import { useEffect } from 'react'
import { createPortal } from 'react-dom'

import {
  CmmsScrollViewer,
  type CmmsScrollViewerProps,
} from './CmmsScrollViewer'
import { WorkOrderFullscreen } from './workOrderViewerStyles'

export function CmmsScrollLightbox({
  onClose,
  ...props
}: CmmsScrollViewerProps & { onClose: () => void }) {
  useEffect(() => {
    const keydown = (event: KeyboardEvent) => {
      if (event.key === 'Escape') onClose()
    }
    document.addEventListener('keydown', keydown)
    return () => document.removeEventListener('keydown', keydown)
  }, [onClose])
  return createPortal(
    <WorkOrderFullscreen role='dialog' aria-modal='true' aria-label={props.alt}>
      <CmmsScrollViewer {...props} onToggleFullscreen={onClose} isFullscreen />
    </WorkOrderFullscreen>,
    document.body
  )
}
